import React from "react";
import { Button } from "react-bootstrap";
import validateBSDDevice from "../../validator/BSDDeviceValidator";
import { createOrUpdateDevice,fetchBsdCategories, fetchDeviceTypes, fetchDisplayColumnCounts } from "../../../../../services/BSDService";
import { MessageType, routeInputInfo } from "../../../../../Constant";
import Select from "react-select";
import PropTypes from "prop-types";

export class CreateBSDDevice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceId: this.props.updateSelection?.deviceId ?? "",
      stopId: this.props.updateSelection?.deviceStop?.stopId ?? "",
      routeId: this.props.updateSelection?.routeIds
        ? this.FilterRouteIds(this.props.updateSelection.routeIds)
        : "",
      form: {},
      bsdCategories: [],
      deviceTypes: [],
      displayColumnCountOptions: [],
      category: this.props.updateSelection?.category ?? "",
      selectedCategory: this.props.updateSelection?.category
        ? {
            label: this.props.updateSelection.category,
            value: this.props.updateSelection.category,
          }
        : "",
      displayColumnCount: this.props.updateSelection?.displayColumnCount ?? "",
      selectedColumnCount: this.props.updateSelection?.displayColumnCount
        ? {
            label: this.props.updateSelection.displayColumnCount,
            value: this.props.updateSelection.displayColumnCount,
          }
        : "",
      deviceType: this.props.updateSelection?.deviceType || 'LED',
    };
  }

  componentDidMount() {
    this.mounted = true;
    this.updateFormErrorState();
    this.fetchAllBsdCategories();
    this.fetchAllDisplayColumnCounts();
    this.fetchAllDeviceTypes();
  }

  fetchAllBsdCategories(){
    fetchBsdCategories()
      .then((response) => {
          this.setState({ bsdCategories: response.map((el)=>{return {label:el,value:el}}) });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  fetchAllDeviceTypes(){
    fetchDeviceTypes()
      .then((response) => {
          this.setState({ deviceTypes: response.map((el)=>{return {label:el,value:el}}) });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  fetchAllDisplayColumnCounts(){
    fetchDisplayColumnCounts()
      .then((response) => {
          this.setState({ displayColumnCountOptions: response.map((el)=>{return {label:el,value:el}}) });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    return (
        <form className="form-horizontal">
          <div className="row mb-3">
            {this.renderInputField(
              <span>Device Id</span>,
              "deviceId",
              "Enter Vehicle No",
              this.props.updateSelection ? this.props.updateSelection.deviceId : "",
              (value) => {
                this.setState(
                  { deviceId: value.target.value.trim() },
                  () => {
                    this.updateFormErrorState();
                  }
                );
              },
              this.props.showInfo || this.props.updateSelection,
              this.props.updateSelection?.deviceId
            )}
            {this.renderInputField(
              "Stop Id",
              "stopId",
              "Enter Stop Id",
              (this.props.updateSelection?.deviceStop?.stopId) || "",
              (value) => {
                this.setState({ stopId: value.target.value.trim() });
              },
              this.props.showInfo,
              (this.props.updateSelection?.deviceStop?.stopId) || ""
            )}
          </div>
          <div className="row mb-3">
            {this.renderInputFieldWithInfo(
              "Route Ids",
              "routeIds",
              "Enter Route Ids",
              this.props.updateSelection?.routeIds
                ? this.FilterRouteIds(this.props.updateSelection.routeIds)
                : "",
              (value) => {
                this.setState({ routeIds: value.target.value.trim() });
              },
              this.props.showInfo,
              (this.props.updateSelection?.routeIds
                ? this.FilterRouteIds(this.props.updateSelection.routeIds)
                : "")
            )}
            {this.renderSelectField(
                <span>Device Type</span>,
                this.state.deviceType && {label: this.state.deviceType, value: this.state.deviceType},
                this.state.deviceTypes,
                (value) => {
                  this.setState({ deviceType: value.label }, () => {
                    this.updateFormErrorState();
                  });
                },
                "Select",
                this.state.rtl
              )}
          </div>
          
          {this.state.deviceType === 'LED' && (
            <div className="row mb-3">
              {this.renderSelectField(
                <span>Display Column</span>,
                this.state.displayColumnCount && {label: this.state.displayColumnCount, value: this.state.displayColumnCount},
                this.state.displayColumnCountOptions,
                (value) => {
                  this.setState({ displayColumnCount: value.label }, () => {
                    this.updateFormErrorState();
                  });
                },
                "Select",
                this.state.rtl
              )}
              {this.renderSelectField(
                <span>Category</span>,
                this.state.category && {label: this.state.category, value: this.state.category},
                this.state.bsdCategories,
                (value) => {
                  this.setState({ category: value.label }, () => {
                    this.updateFormErrorState();
                  });
                },
                "Select",
                this.state.rtl
              )}
            </div>
          )}
          <div className="col-sm-12 form-view">
            <Button onClick={() => this.props.onClose()} bsPrefix="close-btn">Close</Button>
            {!this.props.showInfo && (
              <Button
                bsPrefix="confirm-btn"
                onClick={() => {
                  this.setState({ loading: true });
                  this.fetchAddUpdate();
                }}
                disabled={this.state.form.invalid || this.state.loading}
              >
                {this.state.loading ? "Saving..." : "Save changes"}
              </Button>
            )}
          </div>
        </form>
    );
  }



  renderInputField(label, id, placeholder, defaultValue, onChange, showInfo, spanValue) {
    return (
      <div className="col-sm-6">
        <div className="form-group">
          <label htmlFor="name7" className="control-label col-sm-3 form-label">
            {label}
          </label>
          <div className="col-sm-9 ">
            {showInfo ? (
              <span>{spanValue}</span>
            ) : (
              <span>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  id={id}
                  placeholder={placeholder}
                  onChange={onChange}
                  defaultValue={defaultValue}
                />
              </span>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderSelectField(label, value, options, onChange, placeholder, rtl) {
    return (
      <div className="col-sm-6">
        <div className="form-group">
          <label htmlFor="name7" className="control-label col-sm-3 form-label">
            {label}
          </label>
          <div className="col-sm-9">
            <Select
              closeOnSelect={true}
              onChange={onChange}
              isClearable={false}
              options={options}
              placeholder={placeholder}
              rtl={rtl}
              value={value}
            />
          </div>
        </div>
      </div>
    );
  }

  renderInputFieldWithInfo(label, id, placeholder, defaultValue, onChange, showInfo, spanValue) {
    return (
      <div className="col-sm-6">
        <div className="form-group">
          <label htmlFor="name7" className="control-label col-sm-3 form-label">
            {label}
          </label>
          <div className="col-sm-9">
            <div>
              {!showInfo ? (
                <input
                  type="text"
                  className="form-control"
                  id={id}
                  placeholder={placeholder}
                  onChange={onChange}
                  defaultValue={defaultValue}
                />
              ) : (
                <span>{spanValue}</span>
              )}
              <span className="info-text">{routeInputInfo}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * Used to Add/Update Vehicle
   */
  fetchAddUpdate() {
    createOrUpdateDevice(
      this.props.updateSelection,
      this.state,
      this.props.email
    )
      .then((response) => {
        if (this.mounted) {
          this.setState({ loading: false });
          this.props.onComplete(MessageType.SUCCESS, "Successfully done ");
        }
      })
      .catch((err) => {
        if (err.status === 401 || err.message === "Invalid token") {
          this.props.onComplete(MessageType.ERROR, "Invalid token");
        } else if (this.mounted) {
          this.props.onComplete(
            MessageType.ERROR,
            err.description ? err.description : "Error occurred "
          );
        }
      });
  }

  /**
   * validates device from data
   * @param target
   */
  updateFormErrorState() {
    let formState = validateBSDDevice(this.state);
    this.setState({
      form: formState,
    });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  FilterRouteIds(val) {
    return val.toString();
  }
}

CreateBSDDevice.propTypes = {
  updateSelection: PropTypes.object,
  showInfo: PropTypes.bool,
  onComplete: PropTypes.func,
  onClose: PropTypes.func,
  email: PropTypes.string,
};


export default CreateBSDDevice;